(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heritage-recently-viewed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heritage-recently-viewed')) {
  customElements.define('heritage-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const key = 'notg-recently-viewed-v1';
      const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
      const current = this.dataset.current;
      let history;
      try {
        const stored = JSON.parse(sessionStorage.getItem(key) || '[]');
        history = Array.isArray(stored) ? [...new Set(stored.filter(valid))].slice(0,8) : [];
        if (valid(current)) sessionStorage.setItem(key, JSON.stringify([current,...history.filter(x=>x!==current)].slice(0,8)));
      } catch { return; }
      const handles = history.filter(x=>x!==current).slice(0,4);
      if (!handles.length) return;
      this.controller = new AbortController();
      const timeout = setTimeout(()=>this.controller.abort(),8000);
      const root = this.dataset.root.replace(/\/$/,'');
      const cards = await Promise.all(handles.map(async handle => {
        try {
          const response = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=heritage-recent-card`,{signal:this.controller.signal,credentials:'same-origin'});
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          return doc.querySelector('a.heritage-collectible');
        } catch { return null; }
      }));
      clearTimeout(timeout);
      if (!this.isConnected) return;
      const usable = cards.filter(Boolean);
      if (!usable.length) return;
      this.querySelector('[data-recent-grid]').replaceChildren(...usable.map(card=>document.importNode(card,true)));
      this.hidden = false;
      this.querySelector('[data-clear]').addEventListener('click',()=>{
        try { sessionStorage.removeItem(key); } catch {}
        this.hidden = true;
        this.querySelector('[data-recent-grid]').replaceChildren();
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
